import axios from "axios";
import { buildApiUrl } from "../config/api";

export async function fetchTermBudgetOverview(schoolId, { adminId, teacherId } = {}) {
    const params = new URLSearchParams();
    if (adminId) params.set("adminId", adminId);
    if (teacherId) params.set("teacherId", teacherId);
    const qs = params.toString();
    const { data } = await axios.get(buildApiUrl(`/TermBudget/${schoolId}/overview${qs ? `?${qs}` : ""}`));
    return data;
}

export async function upsertTermBudget(payload) {
    const { data } = await axios.post(buildApiUrl("/TermBudget"), payload);
    return data;
}

export async function reviewTermBudget(id, payload) {
    const { data } = await axios.put(buildApiUrl(`/TermBudget/${id}/review`), payload);
    return data;
}

export async function fetchSchoolMaterialRequests(schoolId, { adminId, teacherId, status, currentTerm } = {}) {
    const params = new URLSearchParams();
    if (adminId) params.set("adminId", adminId);
    if (teacherId) params.set("teacherId", teacherId);
    if (status) params.set("status", status);
    if (currentTerm === false) params.set("currentTerm", "false");
    const qs = params.toString();
    const { data } = await axios.get(buildApiUrl(`/MaterialRequests/school/${schoolId}${qs ? `?${qs}` : ""}`));
    return data;
}

export async function reviewMaterialRequest(id, payload) {
    const { data } = await axios.put(buildApiUrl(`/MaterialRequest/${id}/review`), payload);
    return data;
}

export async function fetchTeacherMaterialRequests(teacherId) {
    const { data } = await axios.get(buildApiUrl(`/MaterialRequests/teacher/${teacherId}`));
    return data;
}

export async function submitMaterialRequest(payload) {
    const { data } = await axios.post(buildApiUrl("/MaterialRequest"), payload);
    return data;
}
